// extracted by mini-css-extract-plugin
module.exports = {"close":"_1xgEXu7"};